var map = {
	"./Airbnb-is-Expensive–Here-Are-5-Smart-Alternatives-for-Cheaper-Stays/eng.md": 1799,
	"./How-to-Travel-Without-Paying-for-Hotels/eng.md": 2036,
	"./This-is-how-home-exchanges-work/eng.md": 4204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6773;